import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Editor from "componentes/editor";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  ButtonGroup,
  Button,
  Form,
  Label,
  Input,
  FormGroup
} from 'reactstrap';
import {
  MdKeyboardReturn,
  MdSave
} from 'react-icons/lib/md';

import Pagina from 'componentes/Pagina';
import ProcessoDetalhe from 'componentes/ProcessoDetalhe';

import { buscarProcesso } from "paginas/processo/actions";

import {
  salvar,
  quandoMudar,
} from "./actions";


class Decisao extends Component {
  componentDidMount() {
    const { processoIdRota, processoId, buscarProcesso } = this.props;
    if (!processoId || (processoIdRota && processoIdRota !== processoId)) {
      buscarProcesso(processoIdRota);
    }
  }

  render() {
    const { salvar, history, quandoMudar, situacoes } = this.props;

    const {
      decisao,
    } = this.props;

    const { situacao: { id: situacaoId } = {} } = decisao;

    return (
      <Pagina title="Registrar Decisão" breadcrumbs={[
        { name: 'Tramitar Processo' },
        { name: 'Registrar Decisão', active: true }
      ]} >

        <ProcessoDetalhe />
        <Form onSubmit={e => salvar(e, history)}>
          <Card tag="fieldset">
            <CardHeader tag="legend">Decisão</CardHeader>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <Label className="lbl-required">Relatório</Label>
                    <Editor chave="decisao" placeholder="Incluir relatório..."/>
                  </FormGroup>
                </Col>
                <Col sm={12}>
                  <FormGroup>
                    <Label for="resultado">Resultado Final</Label>
                    <Input type="select" name="decisao_situacaoId" value={situacaoId} onChange={quandoMudar}>>
                      <option key="" value="" />
                      {
                        situacoes.map(({ id, descricao }) => <option key={id} value={id}>{descricao} </option>)
                      }
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <ButtonGroup size="sm" className="float-right">
                    <Button type="reset" color="secondary" onClick={history.goBack}><MdKeyboardReturn />Voltar</Button>
                    <Button type="submit" color="warning"><MdSave />{' '}Salvar</Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </CardBody>
          </Card >
        </Form>
      </Pagina>
    );
  }
}

const mapStateToProps = (state, { history, match: { params: { id: processoIdRota } } }) => ({
  processoIdRota: processoIdRota ? parseInt(processoIdRota, 10) : "",
  processoId: state.processo.processo.id,
  history,
  decisao: state.decisao.decisao,
  situacoes: state.decisao.situacoes
});

const mapDispatchToProps = dispatch => bindActionCreators({
  buscarProcesso,
  quandoMudar,
  salvar
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Decisao))


// WEBPACK FOOTER //
// ./src/paginas/decisao/index.js